/* Rquiere de mixin.js */

var storeRackModule = {
	data () {
		return {
			listStoreRackModules: [],
			methodsStoreRackModule: {
				get: 'storeRackModules',
				show: 'storeRackModule/',
			},
			paginationStoreRackModules: [],
			searchStoreRackModules: '',
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		getAllStoreRackModules(page = 1) {
			let parameters = '?search=' + this.searchStoreRackModules + '&page=' + page
			this.axiosActionIS(this.apiBackend + this.methodsStoreRackModule.get + parameters, 'GET', 'getAllStoreRackModulesResult')
        },
		getAllStoreRackModulesResult(response) {
			if(response.data.success == true) {
				this.listStoreRackModules = response.data.data
			}
            this.getAllStoreRackModulesResultLocal(response)
		},
        getAllStoreRackModulesResultLocal(response) {
            console.log('getAllStoreRackModulesResultLocal no desarrollado', response)
        },
		getStoreRackModule(id) {
			this.axiosActionIS(this.apiBackend + this.methodsStoreRackModule.show + id, 'GET', 'getStoreRackModuleResult')
		},
        getStoreRackModuleResult(response) {
            this.getStoreRackModuleResultLocal(response)
        },
        getStoreRackModuleResultLocal(response) {
            console.log('getStoreRackModuleResultLocal no está desarrollado', response)
        },
		getStoreRackModuleChildren(id) {
			let url = this.apiBackend + this.methodsStoreRackModule.show + id + '/children'
			console.log(url)
			this.axiosActionIS(url, 'GET', 'getStoreRackModuleChildrenResult')
		},
		getStoreRackModuleChildrenResult(response) {
			this.getStoreRackModuleChildrenResultLocal(response)
		},
		getStoreRackModuleChildrenResultLocal(response) {
			console.log('getStoreRackModuleChildrenResultLocal no desarrollado', response)
		}
	},
};

export default storeRackModule;